import { CreditRating } from '@Config/app.config';
import { externalLoggingApi } from '@Utils/externalLoggingFailure/externalLoggingApi';

interface ICartData {
	name?: string;
	upfrontCollection?: string;
	upfrontProductId?: string;
	vatCollection?: string;
	vatProductId?: string;
}

interface IChargingLogging {
	DISABLE_GREEN_ZERO_PAYMENT: boolean;
	cartData: ICartData[];
	creditRating?: CreditRating;
	ctaLabel?: string;
	installmentPeriod?: string;
	isBuyHbbWfbbProcess?: boolean;
	isBuyNowPayLaterInCart?: boolean;
	isGreenXP?: boolean;
	isLogged: string;
	isMakasibItemInCart?: boolean;
	isPrepaidProcess?: boolean;
	lastUpdateDate?: string;
	namab2b2cZeroUpfront?: boolean;
	onlyGiftCardOrDigitals?: boolean;
	orderId: string;
	pickupDelivery?: boolean;
	skipPaymentScreen?: boolean;
	step: string;
	telemarketer?: boolean;
	totalProductPrice?: string;
}

export const getCartData = (items: ICartData[]): ICartData[] =>
	items.map(({ name, upfrontCollection, upfrontProductId, vatCollection, vatProductId }) => ({
		name,
		upfrontCollection,
		upfrontProductId,
		vatCollection,
		vatProductId,
	}));

export const chargingLogging = ({
	DISABLE_GREEN_ZERO_PAYMENT,
	cartData,
	creditRating,
	ctaLabel = 'Next click',
	installmentPeriod,
	isBuyHbbWfbbProcess,
	isBuyNowPayLaterInCart,
	isGreenXP,
	isLogged,
	isMakasibItemInCart,
	isPrepaidProcess,
	lastUpdateDate,
	namab2b2cZeroUpfront,
	onlyGiftCardOrDigitals,
	orderId,
	pickupDelivery,
	skipPaymentScreen,
	step,
	telemarketer,
	totalProductPrice,
}: IChargingLogging) => {
	const pathName = location.href;
	const LoggingData = {
		functionalFlow: 'DoubleCharged',
		warningText: `${ctaLabel} on ${pathName}`,
		errorCode: `DC-${step}`,
		request: JSON.stringify({
			DISABLE_GREEN_ZERO_PAYMENT,
			cartData,
			creditRating,
			installmentPeriod,
			isBuyHbbWfbbProcess,
			isBuyNowPayLaterInCart,
			isGreenXP,
			isLogged,
			isMakasibItemInCart,
			isPrepaidProcess,
			lastUpdateDate,
			namab2b2cZeroUpfront,
			onlyGiftCardOrDigitals,
			orderId,
			pickupDelivery,
			skipPaymentScreen,
			step,
			telemarketer,
			totalProductPrice,
		}),
		response: '',
	};

	externalLoggingApi(LoggingData);
};
